<template>
    <div class="modals-container">
        <div
            v-for="item in $modals"
            :key="item.id">
            <component
                :is="getComponentByType(item.type)"
                :modal="item.modal"
                @close="$modal.close(item.id)" />
        </div>
    </div>
</template>
<script>
import ModalDynamicWrapper from './ModalDynamicWrapper.vue';
import ModalWrapper from './ModalWrapper.vue';
import ModalBottomWrapper from './ModalBottomWrapper.vue';

export default {
    inject: ['$modals'],
    methods: {
        getComponentByType(type) {
            if (type === 'dynamic') {
                return ModalDynamicWrapper;
            }
            if (type === 'bottom') {
                return ModalBottomWrapper;
            }

            return ModalWrapper;
        },
    },
};
</script>
